/**
 * Códigos de auth0-spa-js que significan "esta sesión ya NO puede emitir
 * tokens": refresh token consumido/rotado/caducado/revocado, o el tenant
 * exige interacción del usuario (re-login, consentimiento, MFA). Ante
 * cualquiera de ellos reintentar es inútil — cada intento es otro POST
 * condenado a /oauth/token — y la única salida es re-autenticar.
 *
 * Cualquier otro error (red caída, timeout) es transitorio: tratarlo como
 * sesión muerta dejaría fuera al usuario por un hipo (app#558).
 */
export const AUTH_DEAD_ERRORS: ReadonlySet<string> = new Set([
  'missing_refresh_token',
  'login_required',
  'invalid_grant',
  'consent_required',
  'interaction_required',
  'mfa_required',
]);

/** true si el error de auth0-spa-js indica una sesión incapaz de emitir tokens. */
export function isAuthDeadError(err: unknown): boolean {
  return AUTH_DEAD_ERRORS.has((err as { error?: string })?.error ?? '');
}
